import type { PublicSeccionResponse } from '@ahora-patagonia/contracts';

/**
 * Lo que el sitio necesita de una sección que **no es una categoría**: `/ultima-hora` y
 * `/mas-leidas`.
 *
 * Es la respuesta de la API tal cual. El alias existe para que las vistas y el ViewModel no
 * dependan del nombre del contrato, igual que `CategoriaData`.
 */
export type SeccionData = PublicSeccionResponse;

/** Las dos secciones con página propia que no salen de `categories`. */
export const SECCION_KIND = {
  ultimaHora: 'ultima-hora',
  masLeidas: 'mas-leidas',
} as const;
export type SeccionKind = (typeof SECCION_KIND)[keyof typeof SECCION_KIND];
